import Result from '@/components/result/Result';
export default {
  name: 'AddActivitySuccess',
  i18n: require('../i18n-activity'),
  components: {
    Result: Result
  },
  data: function data() {
    return {
      typeValue: {
        activityType: undefined
      },
      typeVisible: false,
      typeRules: {
        activityType: [{
          required: true,
          message: this.$t('activity.typeprop'),
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    addNewActivity: function addNewActivity() {
      // this.typeVisible = true
      this.typeValue.activityType = undefined;
      this.$emit('finish', this.typeValue.activityType);
      // this.$emit('finish')
    },
    release: function release() {
      this.$emit("release");
    },
    /* 取消选择类型 */resetType: function resetType() {
      this.typeValue.activityType = undefined;
      this.typeVisible = false;
    },
    finish: function finish() {
      var _this = this;
      this.$refs.dataTypeForm.validate(function (valid) {
        if (valid) {
          _this.$emit('finish', _this.typeValue.activityType);
          _this.typeVisible = false;
        }
      });
    }
  }
};